export const FETCHING_SALE_FORECAST_BY_DEALERS = '@@toyota/FETCHING_SALE_FORECAST_BY_DEALERS';
export const FETCHED_SALE_FORECAST_BY_DEALERS = '@@toyota/FETCHED_SALE_FORECAST_BY_DEALERS';
export const FETCHED_SALE_FORECAST_BY_DEALERS_FAILED = '@@toyota/FETCHED_SALE_FORECAST_BY_DEALERS_FAILED';
export const FETCHING_SALE_FORECAST = '@@toyota/FETCHING_SALE_FORECAST';
export const FETCHED_SALE_FORECAST = '@@toyota/FETCHED_SALE_FORECAST';
export const FETCHED_SALE_FORECAST_FAILED = '@@toyota/FETCHED_SALE_FORECAST_FAILED';
export const CLEAR_SALE_FORECAST_LIST = '@@toyota/CLEAR_SALE_FORECAST_LIST';
export const SAVING_SALE_FORECAST_DATA = '@@toyota/SAVING_SALE_FORECAST_DATA';
export const SAVED_SALE_FORECAST_DATA = '@@toyota/SAVED_SALE_FORECAST_DATA';
export const SAVED_SALE_FORECAST_DATA_FAILED = '@@toyota/SAVED_SALE_FORECAST_DATA_FAILED';


// mantain saleforcast
export const FETCHING_MAINTAIN_SALE_FORECAST = '@@toyota/FETCHING_MAINTAIN_SALE_FORECAST';
export const FETCHED_MAINTAIN_SALE_FORECAST = '@@toyota/FETCHED_MAINTAIN_SALE_FORECAST';
export const FETCHED_MAINTAIN_SALE_FORECAST_FAILED = '@@toyota/FETCHED_MAINTAIN_SALE_FORECAST_FAILED';

export const EDITING_MAINTAIN_SALE_FORECAST = '@@toyota/EDITING_MAINTAIN_SALE_FORECAST';
export const EDITED_MAINTAIN_SALE_FORECAST = '@@toyota/EDITED_MAINTAIN_SALE_FORECAST';
export const EDITED_MAINTAIN_SALE_FORECAST_FAILED = '@@toyota/EDITED_MAINTAIN_SALE_FORECAST_FAILED';

export const CLEAR_MAINTAIN_FORECAST_AGENCIES_LIST = '@@toyota/CLEAR_MAINTAIN_FORECAST_AGENCIES_LIST';

